import { appConfig } from 'brand-config';

/**
 * Whether a billing hold lets manual payments through on this brand (#37417). On the mutuals (CFM,
 * Forreston, Oakwood) a hold only stops automated billing and automated cancellation; agents and staff
 * can always take a payment, so an agent never has to ask the mutual to lift a migration hold first.
 * Branch keeps "remove the hold before making a manual charge". Read from the build-time brand config.
 */
export const isManualPaymentsThroughBillingHoldEnabled = () =>
  Boolean(appConfig?.featureFlags?.manualPaymentsThroughBillingHold);
